let audioCtx = null;

function getAudioContext() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    if (!audioCtx || audioCtx.state === 'closed') {
      audioCtx = new AC();
    }
    if (audioCtx.state === 'suspended') {
      void audioCtx.resume();
    }
    return audioCtx;
  } catch {
    return null;
  }
}

function playTone(frequency, durationSec, peakGain = 0.12) {
  const ctx = getAudioContext();
  if (!ctx) return;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.type = 'sine';
  osc.frequency.setValueAtTime(frequency, ctx.currentTime);
  gain.gain.setValueAtTime(0.0001, ctx.currentTime);
  gain.gain.exponentialRampToValueAtTime(peakGain, ctx.currentTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + durationSec);
  osc.start(ctx.currentTime);
  osc.stop(ctx.currentTime + durationSec + 0.01);
}

/** @param {'success' | 'error'} kind */
export function playScanBeep(kind) {
  if (kind === 'success') {
    playTone(880, 0.12);
  } else {
    playTone(220, 0.08, 0.1);
  }
}

export function vibrateScanResult(ok) {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(ok ? 30 : [40, 30, 40]);
  }
}
